export const CONFIG = {
	RPC_URL: "https://apechain.calderachain.xyz/http",
	STAKING_CONTRACT: "0x6253707e7905d752ab816ef9d91a50e89bca9204",
	GEM_TOKEN: "0x11719053d22962420B38235626b4A6809a4859d7",
	CHAIN_ID: 33139,
	CHAIN_NAME: "ApeChain",
	REOWN_PROJECT_ID: "b0b6fcfd4eb1eccb6722c200359d5e7a",
	APESCAN_API_KEY: "7GUAX9KEWZD8EC6CA21IRZ4EEX1HN96TQC",
	APESCAN_API_URL: "https://api.apescan.io/api",
	CONTRACT_FUNCTIONS: {
		GET_STAKING_POOLS: "getPools",
		GET_USER_INFO: "getUserInfo",
		GET_PENDING_REWARD: "getPendingReward",
		GET_PLATFORM_STATS: "getStats",
		GET_PLATFORM_METRICS: "getMetrics",
	},
	VERCEL: {
		ANALYTICS_DEBUG: true,
		SPEED_INSIGHTS_DEBUG: true,
	}
} as const;